'use strict';

var PanelNav = function(config) {
  var self = this;

  self.clickHandler = function() {
    $(config.panelNavButton).on('click', function() {
      var $this = $(this);
      var year = $this.attr('data-year');
      self.parseNavLinks(year);
    });
  }

  self.parseNavLinks = function(year) {
    $(config.navInnerLink).each(function() {
      var $this = $(this);
      var buttonYear = $this.attr('data-year');

      if (buttonYear === year) {
        $this.trigger('click');
      }
    });
  }

  self.init = function() {
    self.clickHandler();
  }
};

module.exports = PanelNav;
